export default "__VITE_ASSET__b_fgbDzE__"